import {Components, Theme} from "@mui/material";

export default {
  MuiContainer: {
    defaultProps: {
      maxWidth: false,
    },
    styleOverrides: {
      root: ({theme}) => ({
        [theme.breakpoints.up('xxxl')]: {
          maxWidth: '1440px',
        },
        [theme.breakpoints.down('xxl')]: {
          maxWidth: '1346px',
        },
        [theme.breakpoints.down('xl')]: {
          maxWidth: '1260px',
        },
        [theme.breakpoints.down('lg')]: {
          maxWidth: '1024px',
        },
        [theme.breakpoints.down('md')]: {
          maxWidth: '748px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
        },
      }),
    },
  },
  MuiAccordion: {
    styleOverrides: {
      root: ({theme}) => ({
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'background 0.5s ease',

        '&.Mui-expanded': {
          //@ts-ignore
          backgroundColor: theme.palette.grey[1000],
        },
        "&::before": {
          content: 'none'
        }
      })
    }
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: 0,
        minHeight: 'auto',
      },
      content: {
        margin: 0
      }
    }
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        paddingTop: 24,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      text: ({theme}) => ({
        color: theme.palette.black[100],
        textTransform: 'none',
        fontFamily: 'Pragmatic, Arial, sans-serif',
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '120%',
        fontStyle: 'normal'
      }),
      startIcon: {
        width: 20,
        height: 20,
        marginRight: 4,
      },
      contained: ({theme}) => ({
        ...theme.typography.h6,
        borderRadius: 8,
        textTransform: 'none',
        '&.MuiButton-sizeMedium': {
          paddingTop: 16,
          paddingBottom: 16,
          paddingLeft: 20,
          paddingRight: 20,
        }
      }),
    }
  },
  MuiSelect: {
    styleOverrides: {
      root: ({theme}) => ({
        borderRadius: 12,
        backgroundColor: theme.palette.grey[400],
      }),
      select: {
        paddingTop: 26,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 12,
      },
      icon: ({theme}) => ({
        color: theme.palette.primary.main,
        width: 20,
        height: 20,
        right: 12
      })
    }
  },
  MuiChip: {
    styleOverrides: {
      root: ({theme}) => ({
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        paddingRight: 8,
        paddingLeft: 8,
        borderRadius: 4
      }),
      label: ({theme}) => ({
        ...theme.typography.caption1,
        padding: 0,
      }),
      deleteIcon: {
        color: 'white',
        width: 16,
        height: 16,
        marginLeft: 6,
        marginRight: 0,
        padding: 0
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({theme}) => ({
        ...theme.typography.p3,
        transform: 'unset'
      })
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 12,
        position: 'relative',
        '& > .MuiCheckbox-root': {
          padding: 0,
          marginRight: 8
        },
        '&.Mui-selected': {
          backgroundColor: 'transparent',
        },
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: ({theme}) => ({
        '& .MuiSvgIcon-root': {
          color: theme.palette.grey[200],
        },
        '&.Mui-checked .MuiSvgIcon-root': {
          color: theme.palette.primary.main,
        }
      })
    }
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: 12,
        boxShadow: '8px 8px 32px -4px rgba(0, 19, 57, 0.16)',
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
    }
  }
} as Components<Theme>
